import axios from 'axios'
import types from '../Stores/types'
import { changeAddonStatus as changeAddonStatusFromStore } from './EnitureStore'

const addon_type = 'PLT'

export const getPalletsPlans = token => {
	const config = {
		headers: { authorization: `Bearer ${token}` },
		params: { addon_type },
	}

	return dispatch => {
		dispatch({
			type: 'ALERT_MESSAGE',
			payload: {
				showAlertMessage: false,
				alertMessageType: 'loading',
			},
		})

		axios
			.get(`${process.env.REACT_APP_ENITURE_API_URL}/get-all-pacakges`, config)
			.then(({ data }) => {
				if (!data.error || data?.data?.length === 0) {
					dispatch({ type: types.PLT_PLANS, payload: data.data })
				}

				dispatch({
					type: 'ALERT_MESSAGE',
					payload: {
						alertMessage: data.message,
						showAlertMessage: true,
						alertMessageType: data.error ? 'error' : false,
					},
				})
			})
			.catch(error => {})
	}
}

export const changePlan = (token, plan_package, SetCancelSubsriptionVisible) => {
	return dispatch => {
		dispatch({
			type: 'ALERT_MESSAGE',
			payload: {
				showAlertMessage: true,
				alertMessageType: 'loading',
			},
		})
		axios
			.post(
				`${process.env.REACT_APP_ENITURE_API_URL}/subscribe-package`,
				{ package: plan_package, addon_type },
				{
					headers: { authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				// Special handling for 'disable' action - suppress paid plan requirement error
				const isDisableAction = plan_package === 'disable'
				const isPaidPlanError = data.error && data.message &&
					(data.message.includes('must subscribe to the paid plan') ||
					 data.message.includes('You must subscribe'))

				if (!data.error) {
					dispatch({ type: types.PLT_PLANS, payload: data.data })
				} else if (isDisableAction && isPaidPlanError) {
					// For disable action with paid plan error, treat as success
					dispatch({ type: types.PLT_PLANS, payload: data.data })
				}

				SetCancelSubsriptionVisible(false)

				// Don't show error message for disable action with paid plan requirement
				if (isDisableAction && isPaidPlanError) {
					dispatch({
						type: 'ALERT_MESSAGE',
						payload: {
							alertMessage: 'Auto-renew disabled successfully.',
							showAlertMessage: true,
							alertMessageType: 'success',
						},
					})
				} else {
					dispatch({
						type: 'ALERT_MESSAGE',
						payload: {
							alertMessage: data?.data?.Message ?? data.message,
							showAlertMessage: true,
							alertMessageType: data.error ? 'error' : 'success',
						},
					})
				}
			})
			.catch(() => {
				SetCancelSubsriptionVisible(false)
			})
	}
}

export const getPalletProviderSettings = token => {
	return dispatch => {
		axios
			.get(`${process.env.REACT_APP_ENITURE_API_URL}/pallet-provider-settings`, {
				headers: { authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				if (!data.error) {
					dispatch({ type: types.PLT_PROVIDER_SETTINGS, payload: data.data })
				}
			})
			.catch(() => {})
	}
}

export const savePalletProviderSettings = (token, providers, onDone) => {
	return dispatch => {
		dispatch({
			type: 'ALERT_MESSAGE',
			payload: { showAlertMessage: true, alertMessageType: 'loading' },
		})
		axios
			.post(
				`${process.env.REACT_APP_ENITURE_API_URL}/pallet-provider-settings`,
				{ providers },
				{ headers: { authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				if (!data.error) {
					dispatch({ type: types.PLT_PROVIDER_SETTINGS, payload: data.data })
				}
				dispatch({
					type: 'ALERT_MESSAGE',
					payload: {
						alertMessage: data.error ? data.message : 'Settings have been saved successfully.',
						showAlertMessage: true,
						alertMessageType: data.error ? 'error' : 'success',
					},
				})
				if (onDone) onDone()
			})
			.catch(() => {})
	}
}

export const changeAddonSuspendStatus = (addon_id, token, action) => {
	return dispatch => {
		dispatch({
			type: 'ALERT_MESSAGE',
			payload: {
				showAlertMessage: true,
				alertMessageType: 'loading',
			},
		})

		axios
			.post(
				`${process.env.REACT_APP_ENITURE_API_URL}/suspend-use-addon`,
				{
					package: addon_id,
					addon_type: addon_type,
					suspend: action
				},
				{
					headers: {
						authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ data }) => {
				dispatch({
					type: types.PLT_PLANS,
					payload: data.data,
				})

				dispatch({
					type: 'ALERT_MESSAGE',
					payload: {
						alertMessage: data.message,
						showAlertMessage: true,
						alertMessageType: data.error ? 'error' : 'success',
					},
				})
			})
			.catch(err => {
				console.log(err)
			})
	}
}
